angular.module('qkr.inventory').factory('variantInfrastructureService', ['variantSortingService', 'variantCoefficientService', 'variantHelperService', 'utils', 'gettextCatalog',
        function(variantSortingService, variantCoefficientService, variantHelperService, utils, gettextCatalog) {
    const createNewMarkerText = '(' + gettextCatalog.getString('Create New') + ')';

    const defaultVariantTypes = [{
        id: 0,
        text: gettextCatalog.getString('Size')
    }, {
        id: 1,
        text: gettextCatalog.getString('Colour')
    }, {
        id: 2,
        text: gettextCatalog.getString('Style')
    }];

    const getVariantInfrastructure = function(variants, maxVariants) {
        // The coefficientExponent avoids clashes between options in different variant sets
        const variantCoefficientExponent = String(maxVariants).length;

        const variantInfrastructure = {
            variantSetSummaries: [],
            variantCoefficientList: [],
            variantOptionExclusionList: [],
            variantCoefficientExclusionList: [],
            variantDetailRemovalList: [],
            variantRemovalList: [],
            variantTitleList: [],
            variantTypes: angular.copy(defaultVariantTypes),
            variantCoefficientExponent
        };

        if (variants != null && variants.length > 0) {
            rebuildVariantInfrastructure(variantInfrastructure, variants);
        }

        return variantInfrastructure;
    };

    var rebuildVariantInfrastructure = function(variantInfrastructure, variantDefinitions) {
        stripSystemDefaultVariant(variantDefinitions);
        variantSortingService.sortVariants(variantDefinitions);
        rebuildVariantSetSummaries(variantInfrastructure, variantDefinitions);
        rebuildVariantCoefficientList(variantInfrastructure, variantDefinitions);
        rebuildVariantTitleList(variantInfrastructure);
        rebuildVariantOptionExclusionList(variantInfrastructure);
        rebuildVariantCoefficientExclusionList(variantInfrastructure);
    };

    var stripSystemDefaultVariant = function(variantDefinitions) {
        let removeDefaultVariant = false;

        if (variantDefinitions.length == 1) {
            const variantDefinition = variantDefinitions[0];
            if (variantDefinition.variantDetails.length == 0) {
                removeDefaultVariant = true;
            }
        }

        if (removeDefaultVariant) {
            variantDefinitions.splice(0, 1);
        }
    };

    var rebuildVariantSetSummaries = function(variantInfrastructure, variantDefinitions) {
        const variantSetSummaries = [];

        angular.forEach(variantDefinitions, (variant) => {
            for (let index = 0; index < variant.variantDetails.length; index++) {
                const variantDetail = variant.variantDetails[index];
                let variantSetSummary = variantHelperService.getVariantSetSummaryForVariantType(variantSetSummaries, variantDetail.variantLabel);

                if (variantSetSummary == null) {
                    variantSetSummary = createVariantSetSummary(variantInfrastructure, variant.variantDetails.length, index, variantDetail);

                    if (variantSetSummary.optionColour == null) {
                        variantSetSummary.optionColour = variantHelperService.getNextAvailableOptionColourForVariantSetSummaries(variantSetSummaries);
                    }

                    variantSetSummaries.push(variantSetSummary);
                } else if (!variantHelperService.variantSetOptionExists(variantSetSummary, variantDetail.variantValue)) {
                        const optionCoefficient = variantCoefficientService.calculateOptionCoefficient(variantSetSummary, variantSetSummary.options.length);
                        const variantOption = createVariantSetSummaryOption(variantSetSummary.type, variantDetail.variantValue, optionCoefficient);
                        variantSetSummary.options.push(variantOption);
                    }
            }
        });

        variantInfrastructure.variantSetSummaries = variantSetSummaries;
    };

    var rebuildVariantCoefficientList = function(variantInfrastructure, variantDefinitions) {
        const variantCoefficientList = [];

        angular.forEach(variantDefinitions, (variant) => {
            variantSortingService.sortVariantDetails(variantInfrastructure.variantSetSummaries, variant);

            angular.forEach(variant.variantDetails, (variantDetail) => {
                if (variantDetail.optionColour == null) {
                    setOptionColourOnVariantDetail(variantInfrastructure, variantDetail);
                }
            });

            const coefficient = variantCoefficientService.calculateCoefficientForVariantDetails(variantInfrastructure.variantSetSummaries, variant.variantDetails);

            const variantCoefficient = variantCoefficientService.createVariantCoefficientMap(coefficient, variant);
            variantCoefficientList.push(variantCoefficient);
        });

        variantCoefficientService.sortVariantCoefficientList(variantCoefficientList);
        variantCoefficientService.setVariantCoefficientListPriorities(variantCoefficientList);
        variantInfrastructure.variantCoefficientList = variantCoefficientList;
    };

    const rebuildVariantTypes = function(variantInfrastructure) {
        const variantTypes = angular.copy(defaultVariantTypes);

        // Assign from master variant types first:
        angular.forEach(variantInfrastructure.variantSetSummaries, (variantSetSummary) => {
            let found = false;

            for (let i = 0; i < defaultVariantTypes.length; i++) {
                const defaultVariantType = defaultVariantTypes[i];
                if (variantSetSummary.variantType == defaultVariantType.text) {
                    found = true;
                    break;
                }
            }

            if (!found) {
                const variantType = {
                    id: variantTypes.length,
                    text: variantSetSummary.variantType
                };

                variantTypes.push(variantType);
            }
        });

        variantInfrastructure.variantTypes = variantTypes;
    };

    var rebuildVariantTitleList = function(variantInfrastructure) {
        const variantTitleList = [];

        angular.forEach(variantInfrastructure.variantSetSummaries, (variantSetSummary) => {
            variantTitleList.push(variantSetSummary.type);
        });

        variantInfrastructure.variantTitleList = variantTitleList;
    };

    var rebuildVariantOptionExclusionList = function(variantInfrastructure) {
        const variantOptionExclusionList = [];

        angular.forEach(variantInfrastructure.variantCoefficientList, (variantCoefficient) => {
            angular.forEach(variantCoefficient.variant.variantDetails, (variantDetail) => {
                if (!variantDetail.isGrouped) {
                    const variantSetSummary = variantHelperService.getVariantSetSummaryForVariantType(variantInfrastructure.variantSetSummaries, variantDetail.variantLabel);
                    const variantOption = variantHelperService.getVariantSetSummaryOptionForOptionValue(variantSetSummary, variantDetail.variantValue);

                    const excludedVariantOption = createExcludedVariantOption(variantSetSummary.type, variantOption);
                    variantOptionExclusionList.push(excludedVariantOption);
                }
            });
        });

        variantInfrastructure.variantOptionExclusionList = variantOptionExclusionList;
    };

    var rebuildVariantCoefficientExclusionList = function(variantInfrastructure) {
        const variantCoefficientExclusionList = [];
        const deletionDetectionVariantInfrastructure = angular.copy(variantInfrastructure);
        deletionDetectionVariantInfrastructure.variantCoefficientList = [];

        const product = {amountMinorUnits: 0};
        generateVariants(deletionDetectionVariantInfrastructure, null, null, null, 0, [], product);

        angular.forEach(deletionDetectionVariantInfrastructure.variantCoefficientList, (deletionDetectionVariantCoefficient) => {
            let found = false;

            for (let i = 0; i < variantInfrastructure.variantCoefficientList.length; i++) {
                const variantCoefficient = variantInfrastructure.variantCoefficientList[i];

                if (deletionDetectionVariantCoefficient.coefficient == variantCoefficient.coefficient) {
                    found = true;
                    break;
                }
            }

            if (!found) {
                variantCoefficientExclusionList.push(deletionDetectionVariantCoefficient);
            }
        });

        variantInfrastructure.variantCoefficientExclusionList = variantCoefficientExclusionList;
    };

    const createInitialVariantSetSummary = function(variantInfrastructure, variantDetail, variantSetIndex) {
        const numberOfVariantSets = variantInfrastructure.variantSetSummaries.length;
        const variantSetSummary = createVariantSetSummary(variantInfrastructure, numberOfVariantSets + 1, numberOfVariantSets, variantDetail);

        if (variantSetIndex != null && variantSetIndex < numberOfVariantSets) {
            variantInfrastructure.variantSetSummaries.splice(variantSetIndex, 0, variantSetSummary);
        } else {
            variantInfrastructure.variantSetSummaries.push(variantSetSummary);
        }

        rebuildVariantTitleList(variantInfrastructure);
    };

    var createVariantSetSummary = function(variantInfrastructure, numberOfVariantSetSummaries, indexOfVariantSetSummary, variantDetail) {
        const variantSetSummaryCoefficient = variantCoefficientService.calculateVariantSetSummaryCoefficient(variantInfrastructure, numberOfVariantSetSummaries, indexOfVariantSetSummary);

        const initialVariantSetSummary = {
            id: indexOfVariantSetSummary,
            originalType: null,
            type: variantDetail.variantLabel,
            summaryCoefficient: variantSetSummaryCoefficient,
            options: [],
            optionColour: variantDetail.optionColour
        };

        const initialOptionCoefficient = variantCoefficientService.calculateOptionCoefficient(initialVariantSetSummary, initialVariantSetSummary.options.length);
        initialVariantSetSummary.options.push(createVariantSetSummaryOption(initialVariantSetSummary.type, variantDetail.variantValue, initialOptionCoefficient));

        return initialVariantSetSummary;
    };

    var createVariantSetSummaryOption = function(optionType, optionValue, optionCoefficient) {
        return {
            optionType,
            optionValue,
            optionCoefficient
        };
    };

    const extractVariantSetsFromInfrastructure = function(variantInfrastructure) {
        const variantSets = [];

        angular.forEach(variantInfrastructure.variantSetSummaries, (variantSetSummary) => {
            const variantSet = {
                id: variantSetSummary.id,
                variantType: variantSetSummary.type,
                options: [],
                optionColour: variantSetSummary.optionColour
            };

            angular.forEach(variantSetSummary.options, (option) => {
                variantSet.options.push(option.optionValue);
            });

            variantSets.push(variantSet);
        });

        return variantSets;
    };

    const extractVariantsFromInfrastructure = function(variantInfrastructure) {
        const variantList = [];
        angular.forEach(variantInfrastructure.variantCoefficientList, (variantCoefficient) => {
            variantList.push(variantCoefficient.variant);
        });

        return variantList;
    };

    const extractVariantRemovalListFromInfrastructure = function(variantInfrastructure) {
        return variantInfrastructure.variantRemovalList;
    };

    const extractVariantDetailRemovalListFromInfrastructure = function(variantInfrastructure) {
        return variantInfrastructure.variantDetailRemovalList;
    };

    const extractVariantTypesFromInfrastructure = function(variantInfrastructure) {
        return variantInfrastructure.variantTypes;
    };

    const extractVariantTitleListFromInfrastructure = function(variantInfrastructure) {
        return variantInfrastructure.variantTitleList;
    };

    const addNewOptionToVariantSetSummary = function(variantInfrastructure, skusInUse, variantType, variantSetIndex, newVariantSetOption, product) {
        const variantSetSummary = variantHelperService.getVariantSetSummaryForVariantType(variantInfrastructure.variantSetSummaries, variantType);

        const optionCoefficient = variantCoefficientService.calculateOptionCoefficient(variantSetSummary, variantSetSummary.options.length);
        const variantOption = createVariantSetSummaryOption(variantSetSummary.type, newVariantSetOption, optionCoefficient);
        variantSetSummary.options.push(variantOption);

        generateVariants(variantInfrastructure, skusInUse, variantSetSummary, variantOption, 0, [], product);
        variantCoefficientService.sortVariantCoefficientList(variantInfrastructure.variantCoefficientList);
        variantCoefficientService.setVariantCoefficientListPriorities(variantInfrastructure.variantCoefficientList);
    };

    const isVariantCoefficientInExclusionList = function(variantInfrastructure, variantCoefficientValue) {
        for (let index = 0; index < variantInfrastructure.variantCoefficientExclusionList.length; index++) {
            const excludedVariantCoefficient = variantInfrastructure.variantCoefficientExclusionList[index];
            if (variantCoefficientValue == excludedVariantCoefficient.coefficient) {
                return true;
            }
        }

        return false;
    };

    const removeVariantFromExclusionsList = function(variantInfrastructure, removeVariantCoefficientValue) {
        let removeAtIndex = -1;
        for (let index = 0; index < variantInfrastructure.variantCoefficientExclusionList.length; index++) {
            const excludedVariantCoefficient = variantInfrastructure.variantCoefficientExclusionList[index];
            if (removeVariantCoefficientValue == excludedVariantCoefficient.coefficient) {
                removeAtIndex = index;
                break;
            }
        }

        if (removeAtIndex != -1) {
            variantInfrastructure.variantCoefficientExclusionList.splice(removeAtIndex, 1);
        }
    };

    const addVariantToInfrastructure = function(variantInfrastructure, triggeringVariantSetSummary, triggeringOption, variant, forceInsert) {
        variantSortingService.sortVariantDetails(variantInfrastructure.variantSetSummaries, variant);
        const newVariantCoefficientValue = variantCoefficientService.calculateCoefficientForVariantDetails(variantInfrastructure.variantSetSummaries, variant.variantDetails);

        if (forceInsert) {
            removeVariantFromExclusionsList(variantInfrastructure, newVariantCoefficientValue);
        }

        const variantExcluded = forceInsert ? false : isVariantCoefficientInExclusionList(variantInfrastructure, newVariantCoefficientValue);

        if (!variantExcluded) {
            const newVariantCoefficient = variantCoefficientService.createVariantCoefficientMap(newVariantCoefficientValue, variant);

            let addVariantToExclusionList = false;
            if (!forceInsert && (triggeringVariantSetSummary != null && triggeringOption != null)) {
                addVariantToExclusionList = excludeVariantIfAllSiblingsAreExcluded(variantInfrastructure, triggeringVariantSetSummary, triggeringOption, newVariantCoefficient.coefficient);
            }

            if (addVariantToExclusionList) {
                variantInfrastructure.variantCoefficientExclusionList.push(newVariantCoefficient);
            } else {
                const insertionIndex = variantCoefficientService.getInsertionIndexOfVariantCoefficient(variantInfrastructure.variantCoefficientList, newVariantCoefficient.coefficient);
                if (insertionIndex != -1) {
                    variantInfrastructure.variantCoefficientList.splice(insertionIndex, 0, newVariantCoefficient);
                }
            }
        }
    };

    var excludeVariantIfAllSiblingsAreExcluded = function(variantInfrastructure, differenciatingVariantSetSummary, newSiblingOption, variantCoefficientValue) {
        if (variantInfrastructure.variantCoefficientExclusionList.length > 0) {
            const variantSetSummaryIndex = variantHelperService.getIndexOfVariantSetSummaryForVariantType(variantInfrastructure.variantSetSummaries, differenciatingVariantSetSummary.type);
            const preceedingVariantSetSummaries = variantInfrastructure.variantSetSummaries.slice(0, variantSetSummaryIndex);

            // First isolate the variant's options from the differenciating variantSetSummary
            const isolatedDifferenciantingOpionCoefficient = variantCoefficientService.isolateVariantSetSummaryOptionCoefficientForVariant(differenciatingVariantSetSummary, preceedingVariantSetSummaries, variantCoefficientValue);
            const isolatedVariantCoefficientValue = variantCoefficientValue - isolatedDifferenciantingOpionCoefficient;

            const siblingDifferenciatingOptionCoefficientList = [];

            // Loop through the exclusion list and find the variant sibling's isolated differenciating option coefficients
            angular.forEach(variantInfrastructure.variantCoefficientExclusionList, (excludedVariantCoefficient) => {
                const isolatedExcludedDifferenciantingOpionCoefficient = variantCoefficientService.isolateVariantSetSummaryOptionCoefficientForVariant(differenciatingVariantSetSummary, preceedingVariantSetSummaries, excludedVariantCoefficient.coefficient);
                const isolatedExcludedVariantCoefficientValue = excludedVariantCoefficient.coefficient - isolatedExcludedDifferenciantingOpionCoefficient;

                if (isolatedVariantCoefficientValue == isolatedExcludedVariantCoefficientValue) {
                    siblingDifferenciatingOptionCoefficientList.push(isolatedExcludedDifferenciantingOpionCoefficient);
                }
            });

            // If there's a sibling diffenciating option coefficient for each option in the variant set summary (except the newSiblingOption, then exclude the variant
            for (let i = 0; i < differenciatingVariantSetSummary.options.length; i++) {
                const differenciatingVariantSetSummaryOption = differenciatingVariantSetSummary.options[i];
                if (siblingDifferenciatingOptionCoefficientList.indexOf(differenciatingVariantSetSummaryOption.optionCoefficient) == -1) {
                    if (differenciatingVariantSetSummaryOption.optionCoefficient != newSiblingOption.optionCoefficient) {
                        return false;
                    }
                }
            }
        } else {
            return false;
        }

        return true;
    };

    var createExcludedVariantOption = function(variantType, variantOption) {
        return {
            type: variantType,
            option: variantOption
        };
    };

    const addNewVariant = function(variantInfrastructure, variant) {
        angular.forEach(variant.variantDetails, (variantDetail) => {
            const variantSetSummary = variantHelperService.getVariantSetSummaryForVariantType(variantInfrastructure.variantSetSummaries, variantDetail.variantLabel);

            if (!variantHelperService.variantSetOptionExists(variantSetSummary, variantDetail.variantValue)) {
                variantDetail.isGrouped = false;

                const optionCoefficient = variantCoefficientService.calculateOptionCoefficient(variantSetSummary, variantSetSummary.options.length);
                const variantOption = createVariantSetSummaryOption(variantSetSummary.type, variantDetail.variantValue, optionCoefficient);
                variantSetSummary.options.push(variantOption);

                // Create an exclusion rule that will prevent variant options from being generated.
                const excludedVariantOption = createExcludedVariantOption(variantSetSummary.type, variantOption);
                variantInfrastructure.variantOptionExclusionList.push(excludedVariantOption);
            }
        });

        addVariantToInfrastructure(variantInfrastructure, null, null, variant, true);
        variantCoefficientService.sortVariantCoefficientList(variantInfrastructure.variantCoefficientList);
        variantCoefficientService.setVariantCoefficientListPriorities(variantInfrastructure.variantCoefficientList);
    };

    const removeOptionFromExclusionLists = function(variantInfrastructure, deletedOption) {
        const removalIndexList = [];
        for (let index = 0; index < variantInfrastructure.variantOptionExclusionList.length; index++) {
            const variantOption = variantInfrastructure.variantOptionExclusionList[index];
            if (deletedOption.variantSetSummary.type == variantOption.type) {
                if (deletedOption.variantSetSummaryOption.optionValue == variantOption.option.optionValue) {
                    removalIndexList.push(index);
                }
            }
        }

        for (let i = 0; i < removalIndexList.length; i++) {
            const removalIndex = removalIndexList[i];
            variantInfrastructure.variantOptionExclusionList.splice(removalIndex, 1);
        }
    };

    const removeVariant = function(variantInfrastructure, skusInUse, variant) {
        const coefficient = variantCoefficientService.calculateCoefficientForVariantDetails(variantInfrastructure.variantSetSummaries, variant.variantDetails);
        let variantCoefficientIndex = -1;

        for (let index = 0; index < variantInfrastructure.variantCoefficientList.length; index++) {
            const variantCoefficient = variantInfrastructure.variantCoefficientList[index];
            if (variantCoefficient.coefficient == coefficient) {
                variantCoefficientIndex = index;
                break;
            }
        }

        if (variantCoefficientIndex != -1) {
            deleteVariantAtIndex(variantInfrastructure, skusInUse, variantCoefficientIndex);
            recalculateCoefficientsAndSort(variantInfrastructure);
        }
    };

    const isVariantOptionInExclusionList = function(variantInfrastructure, variantType, variantOption) {
        for (let i = 0; i < variantInfrastructure.variantOptionExclusionList.length; i++) {
            const excludedVariantOption = variantInfrastructure.variantOptionExclusionList[i];

            if (excludedVariantOption.type == variantType) {
                if (excludedVariantOption.option.optionValue.toLowerCase() == variantOption.optionValue.toLowerCase()) {
                    return true;
                }
            }
        }
        return false;
    };

    var generateVariants = function(variantInfrastructure, skusInUse, triggeringVariantSetSummary, triggeringOption, variantSetSummariesIndex, newVariantDetails, product) {
        if (variantInfrastructure.variantSetSummaries.length == variantSetSummariesIndex) {
            // Base case: create a new variant for each option
            const variantDetails = [];
            angular.forEach(newVariantDetails, (newVariantDetail) => {
                variantDetails.push(createNewVariantDetail(true, newVariantDetail.type, newVariantDetail.option, newVariantDetail.optionColour));
            });

            let skuPattern = null;
            if (!utils.hasNoValue(product.sku)) {
                skuPattern = product.sku;
            }

            const sku = variantHelperService.getNextSkuForSkuPattern(variantInfrastructure, skusInUse, skuPattern);

            const variant = createNewVariant(product.amountMinorUnits, sku, product.stockQuantity, true, false, variantDetails);
            addVariantToInfrastructure(variantInfrastructure, triggeringVariantSetSummary, triggeringOption, variant, false);
        } else {
            // Recursive case: get the current variant set summary and spawn a recursive call for each option
            const currentVariantSetSummary = variantInfrastructure.variantSetSummaries[variantSetSummariesIndex];
            const indexOfNextVariantSetSummary = variantSetSummariesIndex + 1;

            // Spawn a new method call for each option - unless the option is in the exclusiont list
            for (let i = 0; i < currentVariantSetSummary.options.length; i++) {
                const currentOption = currentVariantSetSummary.options[i];

                if (!isVariantOptionInExclusionList(variantInfrastructure, currentVariantSetSummary.type, currentOption)) {
                    const currentVariantDetails = utils.copyArray(newVariantDetails);
                    currentVariantDetails.push({type: currentVariantSetSummary.type, option: currentOption.optionValue, optionColour: currentVariantSetSummary.optionColour});

                    generateVariants(variantInfrastructure, skusInUse, triggeringVariantSetSummary, triggeringOption, indexOfNextVariantSetSummary, currentVariantDetails, product);
                }
            }
        }
    };

    var createNewVariant = function(amountMinorUnits, sku, newStockQuantity, visible, isDefault, variantDetails) {
        return new Variant(amountMinorUnits, sku, newStockQuantity, visible, isDefault, variantDetails);
    };

    var createNewVariantDetail = function(isVisible, variantLabel, variantValue, optionColour) {
        return new VariantDetail(isVisible, variantLabel, variantValue, optionColour);
    };

    var Variant = function(amountMinorUnits, sku, newStockQuantity, visible, isDefault, variantDetails) {
        this.variantId = null;
        this.amountMinorUnits = amountMinorUnits;
        this.sku = sku;
        this.currentStockQuantity = 0;
        this.stockQuantity = newStockQuantity;
        this.visible = visible;
        this.isDefault = isDefault;
        this.variantDetails = variantDetails;
    };

    var VariantDetail = function(isVisible, variantLabel, variantValue, optionColour) {
        this.id = null;
        this.isVisible = isVisible;
        this.isGrouped = true;
        this.variantLabel = variantLabel;
        this.variantValue = variantValue;
        this.optionColour = optionColour;
    };

    var recalculateCoefficientsAndSort = function(variantInfrastructure) {
        if (variantInfrastructure.variantSetSummaries.length > 0) {
            angular.forEach(variantInfrastructure.variantSetSummaries, (variantSetSummary, index) => {
                variantCoefficientService.recalculateVariantSetSummaryOptionCoefficients(variantInfrastructure, variantSetSummary, index);
            });
        } else {
            variantInfrastructure.variantCoefficientExclusionList = [];
            variantInfrastructure.variantOptionExclusionList = [];
        }

        variantCoefficientService.recalculateVariantCoefficients(variantInfrastructure);
        variantCoefficientService.sortVariantCoefficientList(variantInfrastructure.variantCoefficientList);
        variantCoefficientService.setVariantCoefficientListPriorities(variantInfrastructure.variantCoefficientList);
        rebuildVariantTitleList(variantInfrastructure);
    };

    const reorderVariants = function(variantInfrastructure, variantType, variantSetOption, newVariantSetOptionIndex) {
        const variantSetSummaryIndex = variantHelperService.getIndexOfVariantSetSummaryForVariantType(variantInfrastructure.variantSetSummaries, variantType);
        const variantSetSummary = variantInfrastructure.variantSetSummaries[variantSetSummaryIndex];

        const currentVariantSetOptionIndex = variantHelperService.getIndexOfVariantSetSummaryOptionForOptionValue(variantSetSummary, variantSetOption);

        const splicedVariantSetOptionList = variantSetSummary.options.splice(currentVariantSetOptionIndex, 1);
        variantSetSummary.options.splice(newVariantSetOptionIndex, 0, splicedVariantSetOptionList[0]);

        variantCoefficientService.recalculateVariantSetSummaryOptionCoefficients(variantInfrastructure, variantSetSummary, variantSetSummaryIndex);
        variantCoefficientService.recalculateVariantCoefficients(variantInfrastructure);
        variantCoefficientService.sortVariantCoefficientList(variantInfrastructure.variantCoefficientList);
        variantCoefficientService.setVariantCoefficientListPriorities(variantInfrastructure.variantCoefficientList);

        rebuildVariantTitleList(variantInfrastructure);
    };

    const buildMatchedExcludedVariantCoefficientList = function(variantInfrastructure, variantSetSummary) {
        const matchedExcludedVariantCoefficientList = [];
        const variantSetSummaryIndex = variantHelperService.getIndexOfVariantSetSummaryForVariantType(variantInfrastructure.variantSetSummaries, variantSetSummary.type);
        const preceedingVariantSetSummaries = variantInfrastructure.variantSetSummaries.slice(0, variantSetSummaryIndex);

        // Go through each excluded variant. remove the deleted option. if there are Num VariantSet option matches - then we've found a potentially collapsable variant
        angular.forEach(variantInfrastructure.variantCoefficientExclusionList, (excludedVariantCoefficient) => {
            const deletedVariantSetOptionCoefficientValue = variantCoefficientService.isolateVariantSetSummaryOptionCoefficientForVariant(variantSetSummary, preceedingVariantSetSummaries, excludedVariantCoefficient.coefficient);
            const variantCoefficientValueAfterDelete = excludedVariantCoefficient.coefficient - deletedVariantSetOptionCoefficientValue;
            let matchedVariantCoefficientMap = null;

            for (let i = 0; i < matchedExcludedVariantCoefficientList.length; i++) {
                const variantCoefficientMapInList = matchedExcludedVariantCoefficientList[i];
                if (variantCoefficientValueAfterDelete == variantCoefficientMapInList.coefficientValue) {
                    matchedVariantCoefficientMap = variantCoefficientMapInList;
                    break;
                }
            }

            if (matchedVariantCoefficientMap == null) {
                const excludedVariant = angular.copy(excludedVariantCoefficient.variant);
                let removalIndex = -1;
                for (let index = 0; index < excludedVariant.variantDetails.length; index++) {
                    const variantDetail = excludedVariant.variantDetails[index];
                    if (variantDetail.variantLabel == variantSetSummary.type) {
                        removalIndex = index;
                        break;
                    }
                }

                excludedVariant.variantDetails.splice(removalIndex, 1);

                const variantCoefficientMap = {
                    coefficientValue: variantCoefficientValueAfterDelete,
                    variant: excludedVariant,
                    count: 1
                };
                matchedExcludedVariantCoefficientList.push(variantCoefficientMap);
            } else {
                matchedVariantCoefficientMap.count++;
            }
        });

        return matchedExcludedVariantCoefficientList;
    };

    const deleteVariantSet = function(variantInfrastructure, skusInUse, variantSet) {
        // First check if all sibling variant coefficients will be removed by deleting this variant set.
        const variantSetSummary = variantHelperService.getVariantSetSummaryForVariantType(variantInfrastructure.variantSetSummaries, variantSet.variantType.text);
        if (variantSetSummary == null) {
            return;
        }

        const numberOfOptions = variantSetSummary.options.length;

        const matchedExcludedVariantCoefficientList = buildMatchedExcludedVariantCoefficientList(variantInfrastructure, variantSetSummary);

        if (numberOfOptions > 0) {
            angular.forEach(variantSet.options, (option) => {
                deleteVariantOption(variantInfrastructure, skusInUse, variantSet.variantType.text, option);
            });
        } else {
            const indexOfVariantSetSummary = variantHelperService.getIndexOfVariantSetSummaryForVariantType(variantInfrastructure.variantSetSummaries, variantSetSummary.type);
            variantInfrastructure.variantSetSummaries.splice(indexOfVariantSetSummary, 1);
        }

        const removeVariantOptionExclusionIndexList = [];
        angular.forEach(variantInfrastructure.variantOptionExclusionList, (excludedVariantOption, index) => {
            if (excludedVariantOption.type == variantSet.variantType.text) {
                removeVariantOptionExclusionIndexList.push(index);
            }
        });

        while (removeVariantOptionExclusionIndexList.length != 0) {
            const removeVariantOptionExclusionIndex = removeVariantOptionExclusionIndexList.pop();
            variantInfrastructure.variantOptionExclusionList.splice(removeVariantOptionExclusionIndex, 1);
        }

        for (let i = 0; i < matchedExcludedVariantCoefficientList.length; i++) {
            const matchedVariantCoefficientMap = matchedExcludedVariantCoefficientList[i];
            if (matchedVariantCoefficientMap.count == numberOfOptions) {
                // Create a collapsed excluded varaiant after the delete takes place.
                const collapsedExcludedVariant = variantCoefficientService.createVariantCoefficientMap(matchedVariantCoefficientMap.coefficientValue, matchedVariantCoefficientMap.variant);
                variantInfrastructure.variantCoefficientExclusionList.push(collapsedExcludedVariant);
            }
        }
    };

    const createDeletionResult = function() {
        return {
            deletedVariantCoefficient: null,
            deletedVariantOptionList: []
        };
    };

    const removeSkuFromSkusInUse = function(skusInUse, variant) {
        if (variant != null && !utils.hasNoValue(variant.variantId) && !utils.hasNoValue(variant.sku)) {
            let removalIndex = -1;

            for (let index = 0; index < skusInUse.length; index++) {
                const skuInUse = skusInUse[index];
                if (skuInUse.toLowerCase() == variant.sku.toLowerCase()) {
                    removalIndex = index;
                    break;
                }
            }

            if (removalIndex != -1) {
                skusInUse.splice(removalIndex, 1);
            }
        }
    };

    var deleteVariantAtIndex = function(variantInfrastructure, skusInUse, deleteVariantIndex) {
        const deletionResult = createDeletionResult();

        const deletedVariantCoefficient = variantInfrastructure.variantCoefficientList.splice(deleteVariantIndex, 1)[0];
        deletionResult.deletedVariantCoefficient = deletedVariantCoefficient;

        const deletedVariant = deletedVariantCoefficient.variant;
        removeSkuFromSkusInUse(skusInUse, deletedVariant);

        if (deletedVariant.variantId != null) {
            variantInfrastructure.variantRemovalList.push(angular.copy(deletedVariant.variantId));
        }

        const deleteVariantOptionList = [];

        for (var i = 0; i < deletedVariant.variantDetails.length; i++) {
            // Get the variantSetSummary optionCoefficient for this detail.
            // If no other variants have this option, then delete it.
            const variantDetail = deletedVariant.variantDetails[i];

            const variantSetSummary = variantHelperService.getVariantSetSummaryForVariantType(variantInfrastructure.variantSetSummaries, variantDetail.variantLabel);
            const variantSetSummaryOption = variantHelperService.getVariantSetSummaryOptionForOptionValue(variantSetSummary, variantDetail.variantValue);
            const variantWithOptionExists = variantHelperService.variantExistsWithVariantSetOption(variantInfrastructure, variantSetSummary, variantSetSummaryOption);

            if (!variantWithOptionExists) {
                deleteVariantOptionList.push({variantSetSummary, variantSetSummaryOption});
            }
        }

        for (let j = 0; j < deleteVariantOptionList.length; j++) {
            const deleteVariantOptionObject = deleteVariantOptionList[j];
            const indexOfVariantSetOption = variantHelperService.getIndexOfVariantSetSummaryOptionForOptionValue(deleteVariantOptionObject.variantSetSummary, deleteVariantOptionObject.variantSetSummaryOption.optionValue);

            deletionResult.deletedVariantOptionList.push(deleteVariantOptionObject);
            deleteVariantOptionObject.variantSetSummary.options.splice(indexOfVariantSetOption, 1);
        }

        if (deletionResult.deletedVariantOptionList.length > 0) {
            for (var i = 0; i < deletionResult.deletedVariantOptionList.length; i++) {
                const deletedOption = deletionResult.deletedVariantOptionList[i];
                removeOptionFromExclusionLists(variantInfrastructure, deletedOption);
            }
        } else {
            variantInfrastructure.variantCoefficientExclusionList.push(deletionResult.deletedVariantCoefficient);
        }
    };

    const getValueForVariantDetailRemovalList = function(variantSetSummary) {
        return variantSetSummary.originalType != null ? variantSetSummary.originalType : variantSetSummary.type;
    };

    const deleteVariantsInVariantIndexList = function(variantInfrastructure, skusInUse, variantSetSummary, variantSetSummaryIndex, deletedVariantSetSummaryOption, deleteVariantIndexList) {
        while (deleteVariantIndexList.length != 0) {
            let deleteVariant = false;
            let deleteVariantDetail = false;

            const deleteVariantIndex = deleteVariantIndexList.pop();
            const variantCoefficient = variantInfrastructure.variantCoefficientList[deleteVariantIndex];

            var remainingVariantSetOptions = [];
            const remainingVariantDetails = angular.copy(variantCoefficient.variant.variantDetails);
            remainingVariantDetails.splice(variantSetSummaryIndex, 1);

            angular.forEach(remainingVariantDetails, (remainingVariantDetail) => {
                const variantSetSummary = variantHelperService.getVariantSetSummaryForVariantType(variantInfrastructure.variantSetSummaries, remainingVariantDetail.variantLabel);
                const variantSetSummaryOption = variantHelperService.getVariantSetSummaryOptionForOptionValue(variantSetSummary, remainingVariantDetail.variantValue);
                remainingVariantSetOptions.push(variantSetSummaryOption);
            });

            const currentNumberOfVariantsWithRemainingOptions = variantHelperService.getNumberOfVariantsWithVariantSetOptionList(variantInfrastructure, remainingVariantSetOptions);

            if (currentNumberOfVariantsWithRemainingOptions == 1) {
                deleteVariantDetail = true;
            } else {
                deleteVariant = true;
            }

            if (deleteVariantDetail) {
                variantCoefficient.variant.variantDetails.splice(variantSetSummaryIndex, 1);
            }

            if (deleteVariant) {
                const variantToDelete = variantInfrastructure.variantCoefficientList[deleteVariantIndex].variant;
                removeSkuFromSkusInUse(skusInUse, variantToDelete);

                variantInfrastructure.variantCoefficientList.splice(deleteVariantIndex, 1);

                if (variantCoefficient.variant.variantId != null) {
                    variantInfrastructure.variantRemovalList.push(angular.copy(variantCoefficient.variant.variantId));
                    variantCoefficient.variant.variantId = null;
                }
            }
        }

        if (variantSetSummary.options.length == 0) {
            variantInfrastructure.variantSetSummaries.splice(variantSetSummaryIndex, 1);
            variantInfrastructure.variantDetailRemovalList.push(getValueForVariantDetailRemovalList(variantSetSummary));
        }
    };

    var deleteVariantOption = function(variantInfrastructure, skusInUse, variantType, variantSetOption) {
        const variantSetSummaryIndex = variantHelperService.getIndexOfVariantSetSummaryForVariantType(variantInfrastructure.variantSetSummaries, variantType);
        const variantSetSummary = variantInfrastructure.variantSetSummaries[variantSetSummaryIndex];

        const currentVariantSetOptionIndex = variantHelperService.getIndexOfVariantSetSummaryOptionForOptionValue(variantSetSummary, variantSetOption);
        const splicedVariantSetOptionList = variantSetSummary.options.splice(currentVariantSetOptionIndex, 1);
        const deletedVariantSetSummaryOption = splicedVariantSetOptionList[0];

        const preceedingVariantSetSummaries = variantInfrastructure.variantSetSummaries.slice(0, variantSetSummaryIndex);

        const deleteVariantIndexList = [];

        angular.forEach(variantInfrastructure.variantCoefficientList, (variantCoefficient, index) => {
            const isolatedCoefficient = variantCoefficientService.isolateVariantSetSummaryOptionCoefficientForVariant(variantSetSummary, preceedingVariantSetSummaries, variantCoefficient.coefficient);

            if (deletedVariantSetSummaryOption.optionCoefficient == isolatedCoefficient) {
                deleteVariantIndexList.push(index);
            }
        });

        deleteVariantsInVariantIndexList(variantInfrastructure, skusInUse, variantSetSummary, variantSetSummaryIndex, deletedVariantSetSummaryOption, deleteVariantIndexList);
    };

    const resolveOutOfStepVariants = function(variantInfrastructure, skusInUse, variantType, variantSetOption) {
        // Put all variants back in step by doing the least amount of changes
        if (variantInfrastructure.variantCoefficientList.length > 1) {
            const variantDetailLengthToCountList = getVariantDetailLengthToCountList(variantInfrastructure);

            if (variantDetailLengthToCountList.length > 1) {
                const majorityVariantDetailLengthToCount = getMajorityVariantDetailLengthToCount(variantDetailLengthToCountList);
                const conformingVariantSetSummaries = getConformingVariantSetSummaries(variantInfrastructure, majorityVariantDetailLengthToCount);

                // Go through the list and get the variantCoefficients for each variantDetail count.
                let indexListOfVariantsToDelete = [];
                let indexListOfVariantDetailsToDelete = [];

                const variantSetSummaryOptionsToDelete = [];

                angular.forEach(variantDetailLengthToCountList, (variantDetailLengthToCountInList) => {
                    const variantCoefficientIndexList = variantHelperService.getIndexListOfVariantCoefficientsWithGivenNumberOfVariantDetails(variantInfrastructure.variantCoefficientList, variantDetailLengthToCountInList.variantDetailLength);

                    if (variantDetailLengthToCountInList.variantDetailLength < majorityVariantDetailLengthToCount.variantDetailLength) {
                        indexListOfVariantsToDelete = indexListOfVariantsToDelete.concat(variantCoefficientIndexList);
                    } else if (variantDetailLengthToCountInList.variantDetailLength > majorityVariantDetailLengthToCount.variantDetailLength) {
                        indexListOfVariantDetailsToDelete = indexListOfVariantDetailsToDelete.concat(variantCoefficientIndexList);
                    }
                });

                variantHelperService.sortArrayDescending(indexListOfVariantsToDelete);
                variantHelperService.sortArrayDescending(indexListOfVariantDetailsToDelete);

                const indexListOfNonConformingVariantSetSummaries = [];

                angular.forEach(indexListOfVariantDetailsToDelete, (indexOfVariantWithVariantDetailsToDelete) => {
                    const variantCoefficientWithVariantDetailsToDelete = variantInfrastructure.variantCoefficientList[indexOfVariantWithVariantDetailsToDelete];
                    const nonConformingVariantSetSummaries = deleteNonConformingVariantDetails(variantInfrastructure, variantCoefficientWithVariantDetailsToDelete.variant, conformingVariantSetSummaries);

                    for (let i = 0; i < nonConformingVariantSetSummaries.length; i++) {
                        const nonConformingVariantSetSummary = nonConformingVariantSetSummaries[i];
                        const indexOfNonConformingVariantSetSummary = variantHelperService.getIndexOfVariantSetSummaryForVariantType(variantInfrastructure.variantSetSummaries, nonConformingVariantSetSummary.type);
                        let foundInIndexList = false;

                        for (j = 0; j < indexListOfNonConformingVariantSetSummaries.length; j++) {
                            if (indexOfNonConformingVariantSetSummary == indexListOfNonConformingVariantSetSummaries[j]) {
                                foundInIndexList = true;
                                break;
                            }
                        }

                        if (!foundInIndexList) {
                            indexListOfNonConformingVariantSetSummaries.push(indexOfNonConformingVariantSetSummary);
                        }
                    }
                });

                angular.forEach(indexListOfVariantsToDelete, (indexOfVariantToDelete) => {
                    deleteVariantAtIndex(variantInfrastructure, skusInUse, indexOfVariantToDelete);
                });

                variantHelperService.sortArrayDescending(indexListOfNonConformingVariantSetSummaries);
                angular.forEach(indexListOfNonConformingVariantSetSummaries, (indexOfNonConformingVariantSetSummary) => {
                    const variantSetSummary = variantInfrastructure.variantSetSummaries[indexOfNonConformingVariantSetSummary];
                    variantSetSummary.options.splice(0, variantSetSummary.options.length);
                });
            }
        }
    };

    var getVariantDetailLengthToCountList = function(variantInfrastructure) {
        const variantDetailLengthToCountList = [];

        angular.forEach(variantInfrastructure.variantCoefficientList, (variantCoefficient) => {
            let variantDetailLengthToCount = null;

            for (let i = 0; i < variantDetailLengthToCountList.length; i++) {
                const variantDetailLengthToCountInList = variantDetailLengthToCountList[i];
                if (variantDetailLengthToCountInList.variantDetailLength == variantCoefficient.variant.variantDetails.length) {
                    variantDetailLengthToCount = variantDetailLengthToCountInList;
                    variantDetailLengthToCount.count++;
                    break;
                }
            }

            if (variantDetailLengthToCount == null) {
                variantDetailLengthToCount = {
                    variantDetailLength: variantCoefficient.variant.variantDetails.length,
                    count: 1
                };
                variantDetailLengthToCountList.push(variantDetailLengthToCount);
            }
        });

        return variantDetailLengthToCountList;
    };

    var getMajorityVariantDetailLengthToCount = function(variantDetailLengthToCountList) {
        let majorityVariantDetailLengthToCount = null;

        angular.forEach(variantDetailLengthToCountList, (variantDetailLengthToCountInList) => {
            if (majorityVariantDetailLengthToCount == null || variantDetailLengthToCountInList.count > majorityVariantDetailLengthToCount.count) {
                majorityVariantDetailLengthToCount = variantDetailLengthToCountInList;
            }
        });

        return majorityVariantDetailLengthToCount;
    };

    var getConformingVariantSetSummaries = function(variantInfrastructure, majorityVariantDetailLengthToCount) {
        const conformingVariantSetSummaries = [];

        const majorityVariantCoefficientIndexList = variantHelperService.getIndexListOfVariantCoefficientsWithGivenNumberOfVariantDetails(variantInfrastructure.variantCoefficientList, majorityVariantDetailLengthToCount.variantDetailLength);
        const indexOfFirstConformingVariantCoefficient = majorityVariantCoefficientIndexList[0];
        const conformingVariantDetails = variantInfrastructure.variantCoefficientList[indexOfFirstConformingVariantCoefficient].variant.variantDetails;

        angular.forEach(conformingVariantDetails, (conformingVariantDetail) => {
            const variantSetSummaryForVariantDetail = variantHelperService.getVariantSetSummaryForVariantType(variantInfrastructure.variantSetSummaries, conformingVariantDetail.variantLabel);
            conformingVariantSetSummaries.push(variantSetSummaryForVariantDetail);
        });

        return conformingVariantSetSummaries;
    };

    var deleteNonConformingVariantDetails = function(variantInfrastructure, variant, conformingVariantSetSummaries) {
        const indexListOfVariantDetailsToDelete = [];

        angular.forEach(variant.variantDetails, (variantDetail, index) => {
            let found = false;

            for (let i = 0; i < conformingVariantSetSummaries.length; i++) {
                const variantSetSummary = conformingVariantSetSummaries[i];
                if (variantSetSummary.type == variantDetail.variantLabel) {
                    found = true;
                }
            }

            if (!found) {
                indexListOfVariantDetailsToDelete.push(index);
            }
        });

        const nonConformingVariantSetSummaries = [];

        variantHelperService.sortArrayDescending(indexListOfVariantDetailsToDelete);
        angular.forEach(indexListOfVariantDetailsToDelete, (indexOfVariantDetail) => {
            const variantDetail = variant.variantDetails[indexOfVariantDetail];
            const nonConformingVariantSetSummary = variantHelperService.getVariantSetSummaryForVariantType(variantInfrastructure.variantSetSummaries, variantDetail.variantLabel);

            let variantSetSummaryAlreadyInList = false;

            for (let i = 0; i < nonConformingVariantSetSummaries.length; i++) {
                const nonConformingVariantSetSummaryInList = nonConformingVariantSetSummaries[i];

                if (nonConformingVariantSetSummaryInList.type == nonConformingVariantSetSummary.type) {
                    variantSetSummaryAlreadyInList = true;
                    break;
                }
            }

            if (!variantSetSummaryAlreadyInList) {
                nonConformingVariantSetSummaries.push(nonConformingVariantSetSummary);
            }

            variant.variantDetails.splice(indexOfVariantDetail, 1);
        });

        return nonConformingVariantSetSummaries;
    };

    const removeOrphanedVariantSetSummaries = function(variantInfrastructure) {
        const indexListOfVariantSetSummariesToDelete = [];

        angular.forEach(variantInfrastructure.variantSetSummaries, (variantSetSummary, index) => {
            if (variantSetSummary.options.length == 0) {
                indexListOfVariantSetSummariesToDelete.push(index);
            }
        });

        variantHelperService.sortArrayDescending(indexListOfVariantSetSummariesToDelete);
        angular.forEach(indexListOfVariantSetSummariesToDelete, (indexOfVariantSetSummaryToDelete) => {
            const splicedVariantSetSummaries = variantInfrastructure.variantSetSummaries.splice(indexOfVariantSetSummaryToDelete, 1);
            variantInfrastructure.variantDetailRemovalList.push(getValueForVariantDetailRemovalList(splicedVariantSetSummaries[0]));
        });
    };

    const removeOrphanedVariantOptions = function(variantInfrastructure) {
        angular.forEach(variantInfrastructure.variantSetSummaries, (variantSetSummary) => {
            const removeOptionIndexList = [];
            angular.forEach(variantSetSummary.options, (variantSetSummaryOption, variantSetSummaryOptionIndex) => {
                if (!variantHelperService.variantExistsWithVariantSetOption(variantInfrastructure, variantSetSummary, variantSetSummaryOption)) {
                    removeOptionIndexList.push(variantSetSummaryOptionIndex);
                }
            });

            while (removeOptionIndexList.length != 0) {
                const removeOptionIndex = removeOptionIndexList.pop();
                variantSetSummary.options.splice(removeOptionIndex, 1);
            }
        });
    };

    const reorderVariantDetails = function(variantInfrastructure, variantType, newVariantSetIndex) {
        const variantSetSummaryIndex = variantHelperService.getIndexOfVariantSetSummaryForVariantType(variantInfrastructure.variantSetSummaries, variantType);
        if (variantSetSummaryIndex != newVariantSetIndex && variantSetSummaryIndex != -1) {
            const splicedVariantSetSummariesList = variantInfrastructure.variantSetSummaries.splice(variantSetSummaryIndex, 1);
            variantInfrastructure.variantSetSummaries.splice(newVariantSetIndex, 0, splicedVariantSetSummariesList[0]);

            angular.forEach(variantInfrastructure.variantCoefficientList, (variantCoefficient) => {
                const splicedVariantDetailList = variantCoefficient.variant.variantDetails.splice(variantSetSummaryIndex, 1);
                variantCoefficient.variant.variantDetails.splice(newVariantSetIndex, 0, splicedVariantDetailList[0]);
            });

            recalculateCoefficientsAndSort(variantInfrastructure);
        }
    };

    const variantSetsHaveChanged = function(variantInfrastructure, variantSets) {
        for (let i = 0; i < variantSets.length; i++) {
            const variantSet = variantSets[i];
            const variantSetSummary = variantHelperService.getVariantSetSummaryForVariantType(variantInfrastructure.variantSetSummaries, variantSet.variantType.text);

            if (variantSetSummary != null) {
                if (variantSet.options.length != variantSetSummary.options.length) {
                    return true;
                }

                for (let j = 0; j < variantSet.options.length; j++) {
                    const variantSetOption = variantSet.options[j];
                    const variantSetSummaryOption = variantSetSummary.options[j];

                    if (variantSetOption != variantSetSummaryOption.optionValue) {
                        return true;
                    }
                }
            } else {
                return true;
            }
        }

        return false;
    };

    const changeVariantType = function(variantInfrastructure, oldVariantTypeText, newVariantTypeText) {
        const variantSetSummary = variantHelperService.getVariantSetSummaryForVariantType(variantInfrastructure.variantSetSummaries, oldVariantTypeText);

        if (variantSetSummary != null) {
            if (variantSetSummary.originalType == null) {
                variantSetSummary.originalType = oldVariantTypeText;
            }

            variantSetSummary.type = newVariantTypeText;

            angular.forEach(variantSetSummary.options, (variantSetSummaryOption) => {
                variantSetSummaryOption.optionType = variantSetSummary.type;
            });

            angular.forEach(variantInfrastructure.variantCoefficientList, (variantCoefficient) => {
                const variantDetail = variantHelperService.getVariantDetailForVariantType(variantCoefficient.variant, oldVariantTypeText);
                variantDetail.variantLabel = newVariantTypeText;
            });

            angular.forEach(variantInfrastructure.variantCoefficientExclusionList, (excludedVariantCoefficient) => {
                const variantDetail = variantHelperService.getVariantDetailForVariantType(excludedVariantCoefficient.variant, oldVariantTypeText);
                variantDetail.variantLabel = newVariantTypeText;
            });

            angular.forEach(variantInfrastructure.variantOptionExclusionList, (excludedVariantOption) => {
                if (excludedVariantOption.type == oldVariantTypeText) {
                    excludedVariantOption = newVariantTypeText;
                }
            });

            rebuildVariantTitleList(variantInfrastructure);
        }
    };

    const changeDefaultStockQuantity = function(variantInfrastructure, oldDefaultStockQuantity, newDefaultStockQuantity) {
        angular.forEach(variantInfrastructure.variantCoefficientList, (variantCoefficient) => {
            if (variantCoefficient.variant.stockQuantity == null || variantCoefficient.variant.stockQuantity == oldDefaultStockQuantity) {
                variantCoefficient.variant.stockQuantity = newDefaultStockQuantity;
            }
        });
    };

    var setOptionColourOnVariantDetail = function(variantInfrastructure, variantDetail) {
        const variantSetSummary = variantHelperService.getVariantSetSummaryForVariantType(variantInfrastructure.variantSetSummaries, variantDetail.variantLabel);
        variantDetail.optionColour = variantSetSummary.optionColour;
    };

    return {
        getVariantInfrastructure(variants, maxVariants) {
            return getVariantInfrastructure(variants, maxVariants);
        },

        getCreateNewVariantTypeMarkerText() {
            return createNewMarkerText;
        },

        rebuildVariantSetInfrastructure(variantInfrastructure, variantDefinitions) {
            rebuildVariantInfrastructure(variantInfrastructure, variantDefinitions);
        },

        reorderVariants(variantInfrastructure, variantType, variantSetOption, newVariantSetOptionIndex) {
            reorderVariants(variantInfrastructure, variantType, variantSetOption, newVariantSetOptionIndex);
        },

        reorderVariantDetails(variantInfrastructure, variantType, newVariantSetIndex) {
            reorderVariantDetails(variantInfrastructure, variantType, newVariantSetIndex);
        },

        deleteVariantSet(variantInfrastructure, skusInUse, variantSet) {
            deleteVariantSet(variantInfrastructure, skusInUse, variantSet);
            recalculateCoefficientsAndSort(variantInfrastructure);
            removeOrphanedVariantOptions(variantInfrastructure);
        },

        deleteVariantOption(variantInfrastructure, skusInUse, variantType, variantSetOption) {
            deleteVariantOption(variantInfrastructure, skusInUse, variantType, variantSetOption);
            resolveOutOfStepVariants(variantInfrastructure, skusInUse, variantType, variantSetOption);
            removeOrphanedVariantSetSummaries(variantInfrastructure);
            recalculateCoefficientsAndSort(variantInfrastructure);
            removeOrphanedVariantOptions(variantInfrastructure);
        },

        extractVariantSetsFromInfrastructure(variantInfrastructure) {
            return extractVariantSetsFromInfrastructure(variantInfrastructure);
        },

        extractVariantsFromInfrastructure(variantInfrastructure) {
            return extractVariantsFromInfrastructure(variantInfrastructure);
        },

        extractVariantRemovalListFromInfrastructure(variantInfrastructure) {
            return extractVariantRemovalListFromInfrastructure(variantInfrastructure);
        },

        extractVariantDetailRemovalListFromInfrastructure(variantInfrastructure) {
            return extractVariantDetailRemovalListFromInfrastructure(variantInfrastructure);
        },

        extractVariantTypesFromInfrastructure(variantInfrastructure) {
            return extractVariantTypesFromInfrastructure(variantInfrastructure);
        },

        extractVariantTitleListFromInfrastructure(variantInfrastructure) {
            return extractVariantTitleListFromInfrastructure(variantInfrastructure);
        },

        createInitialVariantSetSummary(variantInfrastructure, variantDetail, variantSetIndex) {
            createInitialVariantSetSummary(variantInfrastructure, variantDetail, variantSetIndex);
        },

        addNewOptionToVariantSetSummary(variantInfrastructure, skusInUse, variantType, variantSetIndex, newVariantSetOption, product) {
            addNewOptionToVariantSetSummary(variantInfrastructure, skusInUse, variantType, variantSetIndex, newVariantSetOption, product);
        },

        addVariantToInfrastructure(variantInfrastructure, variant) {
            addVariantToInfrastructure(variantInfrastructure, null, null, variant, false);
        },

        addNewVariant(variantInfrastructure, variant) {
            addNewVariant(variantInfrastructure, variant);
        },

        removeVariant(variantInfrastructure, skusInUse, variant) {
            removeVariant(variantInfrastructure, skusInUse, variant);
        },

        createNewVariant(amountMinorUnits, sku, stockQuantity, visible, isDefault, variantDetails) {
            return createNewVariant(amountMinorUnits, sku, stockQuantity, visible, isDefault, variantDetails);
        },

        createNewVariantDetail(isVisible, variantLabel, variantValue, optionColour) {
            return createNewVariantDetail(isVisible, variantLabel, variantValue, optionColour);
        },

        variantSetsHaveChanged(variantInfrastructure, variantSets) {
            return variantSetsHaveChanged(variantInfrastructure, variantSets);
        },

        changeVariantType(variantInfrastructure, oldVariantTypeText, newVariantTypeText) {
            return changeVariantType(variantInfrastructure, oldVariantTypeText, newVariantTypeText);
        },

        changeDefaultStockQuantity(variantInfrastructure, oldDefaultStockQuantity, newDefaultStockQuantity) {
            changeDefaultStockQuantity(variantInfrastructure, oldDefaultStockQuantity, newDefaultStockQuantity);
        },

        setOptionColourOnVariantDetail(variantInfrastructure, variantDetail) {
            setOptionColourOnVariantDetail(variantInfrastructure, variantDetail);
        }
    };
}]);



// WEBPACK FOOTER //
// ./src/inventory/services/variantInfrastructure.services.js